import React from 'react';
import './Legal.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-container">
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last Updated: April 27, 2026</p>
      
      <section>
        <h2>1. Introduction</h2>
        <p>At The Claw Gen, we respect your privacy and are committed to protecting your personal data. This Privacy Policy will inform you as to how we look after your personal data when you visit our website and tell you about your privacy rights.</p>
      </section>

      <section>
        <h2>2. Data We Collect</h2>
        <p>We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:</p>
        <ul>
          <li><strong>Identity Data:</strong> includes first name, last name, username or similar identifier.</li>
          <li><strong>Contact Data:</strong> includes email address and telephone numbers.</li>
          <li><strong>Technical Data:</strong> includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location.</li>
          <li><strong>Usage Data:</strong> includes information about how you use our website, products and services.</li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Data</h2>
        <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
        <ul>
          <li>To register you as a new customer.</li>
          <li>To process and deliver your order.</li>
          <li>To manage our relationship with you.</li>
          <li>To improve our website, products/services, marketing or customer relationships.</li>
        </ul>
      </section>

      <section>
        <h2>4. Data Security</h2>
        <p>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed.</p>
      </section>

      <section>
        <h2>5. Your Legal Rights</h2>
        <p>Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to request access, correction, erasure, restriction, transfer, to object to processing, and to withdraw consent.</p>
      </section>

      <section>
        <h2>6. WhatsApp Integration</h2>
        <p>We use the Meta Cloud API to facilitate communication between your WhatsApp account and our AI services. Regarding this integration:</p>
        <ul>
          <li>We store your WhatsApp ID (wa_id) solely to link your account to your specific AI agent deployment.</li>
          <li>We do not store the content of your messages after they have been processed by the AI engine.</li>
          <li>You may request the deletion of your WhatsApp connection data at any time via the dashboard or by contacting support.</li>
        </ul>
      </section>
      
      <div className="legal-back">
        <a href="/">← Back to Home</a>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
